import { useDispatch } from 'react-redux';
import { useAsyncAction } from 'Hooks/Common';
import { GridGetPayload } from 'Interfaces/Grid';
import { $actions } from 'Store/ducks';

export default () => {
  const dispatch = useDispatch();

  return useAsyncAction((payload: GridGetPayload) =>
    $actions.grid.getGrid(dispatch, payload),
  );
};
